import { GET_WEAPON_TYPES_SUCCESS } from "../actionTypes";

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_WEAPON_TYPES_SUCCESS: {
      const weaponTypes = action.payload;

      if (!weaponTypes){
        return [...state];
      }

      return [
        ...state,
        ...weaponTypes
      ]
    }
    default:
      return state;
  }
}
